import React, { useContext } from "react";
import {
  IHighlightCommon,
  IHtmlHighlight,
  IHtmlHighlightInput,
  IPdfHighlightInput,
} from "~/typings/annotate/annotation";

interface IHighlightContext {
  selectedHighlight:
    | IHighlightCommon
    | IPdfHighlightInput
    | IHtmlHighlight
    | IHtmlHighlightInput
    | null
    | undefined;
  openComments: (
    highlight?:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
    startingText?: string,
  ) => any;
  openNote: (
    highlight?:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
    startingText?: string,
  ) => any;
  openInvestigator: (
    highlight?:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
  ) => any;
}
export const HighlightContext = React.createContext<IHighlightContext>({
  selectedHighlight: null,
  openComments: (
    h:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
  ) => {},
  openNote: (
    h:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
  ) => {},
  openInvestigator: (
    highlight?:
      | IHighlightCommon
      | IPdfHighlightInput
      | IHtmlHighlight
      | IHtmlHighlightInput
      | null
      | undefined,
  ) => {},
});
export const useHighlightContext = (): IHighlightContext => {
  return useContext(HighlightContext);
};
